var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.996,
    height: 24.001
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 394",
    d: "M11.998 23.999a12 12 0 010-24v12h12a12.012 12.012 0 01-12 12z",
    fill: "#86c600"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 1",
    d: "M12.998 10.999V.042a12 12 0 0110.957 10.957z",
    fill: "#ffc400"
  }))));
}
export default SvgStats;